import React, { memo, useEffect, useCallback, useState } from 'react';
import Filter from './components/Filter';
import KeyMetrics from './components/KeyMetrics';
import Overview from './components/Overview';
import Budget from './components/Budget';
import BudgetTrend from './components/BudgetTrend';
import Cost from './components/Cost';
import { reportOperationLog } from '@gp/services/global';
import { ALL_REPORT_OPERATION_LOG } from '@gp/constants/operationLogParams';
import { context as Context } from '@gp/components/Context';
import './index.scss';

interface DevPropsType {}

const DEFAULT_PROPS: DevPropsType = {};

function Dev(props: DevPropsType) {
  const {} = props;

  const [filterList, setFilterList] = useState<{
    bo: string[];
    project: string[];
  }>({ bo: [], project: [] });
  // 筛选器中bo与overview列表中studio对应的关系，overview列表接口需要根据这个对应关系传对应的studio
  // const [boStudioMap, setBOStudioMap] = useState<{[keyName: string]: string[]} | null>(null);

  const handleFilterChange = useCallback((payload: { bo: string[]; project: string[]; }) => {
    setFilterList(payload);
  }, []);

  // 页面打点
  useEffect(() => {
    reportOperationLog(ALL_REPORT_OPERATION_LOG.STUDIO_OVERALL_PROJECTS_DEV);
  }, []);

  return (
    <Context.Provider value={{ filter: filterList }}>
      <div className="dbg-studio-overall-projects-development">
        <div className="dbg-studio-overall-projects-development-filter">
          <Filter onChange={handleFilterChange} /* setBOStudioMap={setBOStudioMap} */ />
        </div>

        <KeyMetrics />
        <Overview /* boStudioMap={boStudioMap} */ />
        <Budget />
        <BudgetTrend />
        {/* 暂时屏蔽Quarterly updates表格，保不准后面突然数据正确了 要放出来，不要删这个代码 */}
        {/* <Cost
          type={2}
          subTitle="Quarterly updates, data updated until -"
        /> */}
        <Cost type={1} subTitle="Quarterly updates, data updated until -" />
      </div>
    </Context.Provider>
  );
}

Dev.defaultProps = DEFAULT_PROPS;

export default memo(Dev);
